import React, { useContext, useEffect, useState } from "react";
import ListaIncidentes from "./ListaIncidentes";
import Funcionalidad from "./Funcionalidad";
import GraficoLog from "./GraficoLog";
import GraficoHist from "./GraficoHist";
import Menu2Nivel from "./Menu2Nivel";
import ListaOpciones from "./ListaOpciones";
import AltaIncidente from "./AltaIncidente";
import PlanIncidentes from "./PlanIncidentes";
import { clBasic, codiguera, sizeFiltros } from "./general";
import incidentes from "./img/incidentes.png";
import estadomantenimiento from "./img/estadomantenimiento.png";
import filtroIcon from "./img/filtro.png";
import nuevoIncidente from "./img/nuevoIncidente.png";
import planIncidentes from "./img/planIncidentes.png";
import { AppContext } from "./index";
import { Incidente } from "./contexto/ClasesGrales";
import CerrarVentana from "./CerrarVentana"

export default function EstadoMantenimiento() {
  let { firebase, usrLogged } = useContext(AppContext);

  const [tipo, setTipo] = useState("Todos");
  const [prioridad, setPrioridad] = useState("Todos");
  const [categoria, setCategoria] = useState("Todos");
  const [estado, setEstado] = useState("Todos");
  const [persona, setPersona] = useState("Todas");
  const [plazo, setPlazo] = useState(99);
  const [funcion, setFuncion] = useState("Gráficos");
  const [incidente, setIncidente] = useState(null);
  const [filtros, setFiltros] = useState(false);
  const [mostrarFiltro, setMostrarFiltro] = useState(true);

  useEffect(() => {
    document.getElementById("htmlTituloPag").innerHTML = "Estado de Mantenimiento";
    document.getElementById("htmlTituloPagS").innerHTML = funcion;
    setPlazo(99);
  }, [tipo, prioridad, categoria, estado, persona, funcion]);

  useEffect(() => {
    if (plazo !== 99) setFuncion("Incidentes");
  }, [plazo]);

  useEffect(() => {
    setMostrarFiltro((funcion !== "Incidente" && funcion !== "Alta de Incidente" && funcion !== "Planificacion de Incidentes"));
    setFiltros(false)
  }, [funcion]);

  function FiltroIncidentes() {
    const Sfiltros = {
      position: "relative",
      background: "white",
      padding: "10px",
      border: "1px solid white",
      borderRadius: "5px",
      fontSize: sizeFiltros,
      boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
      color: clBasic
    };
    const Sfiltro = {
      display: "flex",
      flexDirection: "row",
      marginTop: "3px"
    };
    const Setiqueta = {
      minWidth: "7.7vw",
      fontWeight: 500,
      padding: "3px",
    };
    const Sinput = {
      padding: "3px",
      background: "#F2F2F2",
      borderRadius: "5px",
      width: "6vw",
      textAlign: "center",
      cursor: "pointer",
      color: clBasic
    };

    return (
      <div style={Sfiltros}>
        <CerrarVentana set={setFiltros} />
        <div style={Sfiltro}>
          <div style={Setiqueta}>Tipo:</div>
          <div id="FMtipo" style={Sinput}>
            {tipo}
          </div>
        </div>
        <div style={Sfiltro}>
          <div style={Setiqueta}>Prioridad:</div>
          <div id="FMprioridad" style={Sinput}>
            {prioridad}
          </div>
        </div>
        <div style={Sfiltro}>
          <div style={Setiqueta}>Categoría:</div>
          <div id="FMcategoria" style={Sinput}>
            {categoria}
          </div>
        </div>
        <div style={Sfiltro}>
          <div style={Setiqueta}>Estado:</div>
          <div id="FMestado" style={Sinput}>
            {estado}
          </div>
        </div>
        <div style={Sfiltro}>
          <div style={Setiqueta}>Responsable:</div>
          <div id="FMresponsable" style={Sinput}>
            {persona}
          </div>
        </div>
        <ListaOpciones setFiltro={setPrioridad} lista={codiguera["prioridad"]} elemento="FMprioridad" titulo={"Prioridad"} />
        <ListaOpciones setFiltro={setTipo} lista={codiguera["tipo"]} elemento="FMtipo" titulo={"Tipo de Incidente"} />
        <ListaOpciones setFiltro={setCategoria} lista={codiguera["categorias"]} elemento="FMcategoria" titulo={"categoria de Incidentes"} />
        <ListaOpciones setFiltro={setEstado} lista={codiguera["estadoIncidentes"]} elemento="FMestado" titulo={"Estado"} />
        <ListaOpciones setFiltro={setPersona} lista={firebase.filtroPersonas} elemento="FMresponsable" titulo={"Responsable"} />
      </div>
    );
  }

  if (usrLogged.isLogged)
    return (
      <div id="EMprincipal" style={Smantenimiento}>
        <Menu2Nivel>
          <Funcionalidad setF={setFuncion} filtroIcon={nuevoIncidente} funcion={"Alta de Incidente"} />
          <Funcionalidad setF={setFuncion} filtroIcon={incidentes} funcion={"Incidentes"} />
          <Funcionalidad setF={setFuncion} filtroIcon={estadomantenimiento} funcion={"Gráficos"} />
          <Funcionalidad setF={setFuncion} filtroIcon={planIncidentes} funcion={"Planificacion de Incidentes"} />
        </Menu2Nivel>
        <div style={{ position: "absolute", top: "13vh", left: "9vw", zIndex: 8 }}>
          {!filtros && mostrarFiltro && (
            <img
              src={filtroIcon}
              alt="?"
              height="15px"
              width="15px"
              style={{ cursor: "pointer", background: "black" }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.1)}
              onClick={(e) => {
                e.currentTarget.style.opacity = 0.1;
                setFiltros(true);
              }}
            ></img>
          )}
          {filtros && <FiltroIncidentes />}
        </div>

        <div style={Sgraficos}>
          {funcion === "Gráficos" && (
            <>
              <div style={SmarcoGrafico}>
                <GraficoLog
                  tipo={tipo}
                  prioridad={prioridad}
                  categoria={categoria}
                  estado={estado}
                  persona={persona}
                  setPlazo={setPlazo}
                  w={window.innerWidth * 0.47}
                  h={window.innerHeight * 0.88}
                ></GraficoLog>
              </div>
              <div style={SmarcoGrafico}>
                <GraficoHist
                  tipo={tipo}
                  prioridad={prioridad}
                  categoria={categoria}
                  estado={estado}
                  persona={persona}
                  w={window.innerWidth * 0.43}
                  h={window.innerHeight * 0.86}
                ></GraficoHist>
              </div>
            </>
          )}
          {funcion === "Incidentes" && (
            <ListaIncidentes
              tipo={tipo}
              prioridad={prioridad}
              categoria={categoria}
              plazo={plazo}
              estado={estado}
              persona={persona}
              setFuncion={setFuncion}
              setIncidente={setIncidente}
            ></ListaIncidentes>
          )}
          <div style={Smarco15px}>{funcion === "Incidente" && <AltaIncidente incidente={incidente} />}</div>
          <div style={Smarco15px}>{funcion === "Alta de Incidente" && <AltaIncidente incidente={new Incidente(usrLogged.id)} />}</div>
          <div style={Smarco15px}>{funcion === "Planificacion de Incidentes" && <PlanIncidentes />}</div>
        </div>
      </div>
    );
  else return <div style={{ color: clBasic }}>Debe loguearse, gil!!</div>;
}

const Smantenimiento = {
  width: "100vw",
  height: "90vh",
  display: "flex",
  flexDirection: "row",
};

const SmarcoGrafico = {
  position: "relative",
};

const Smarco15px = {
  position: "absolute",
  margin: "15px",
  zIndex: 12,
};

const Sgraficos = {
  position: "relative",
  display: "flex",
  flexDirection: "row",
};
